const { updateExpr } = require('./update-expression');

module.exports.updateExpr = updateExpr;
